/**
 * The body of every sanitised 500 from CalystaAdminAPI's CalystaExceptionHandler. PascalCase --
 * the API sets PropertyNamingPolicy = null. Hand-written rather than generated: this shape is
 * produced by global exception-handling middleware, not by any single endpoint's declared
 * OpenAPI response, so NSwag has no schema for it.
 */
export interface ErrorResponse {
  Message: string;
  ErrorReference: string;
}

/** True if `body` looks like a CalystaExceptionHandler response rather than an arbitrary object. */
export function isErrorResponse(body: unknown): body is ErrorResponse {
  return (
    typeof body === 'object' &&
    body !== null &&
    typeof (body as ErrorResponse).Message === 'string' &&
    typeof (body as ErrorResponse).ErrorReference === 'string'
  );
}
